import { MenuFeatures, SubMenuFeatures } from "@/router/features.js";

/**
 * URL da nova plataforma para onde as telas de telemetria foram migradas.
 */
export const NEW_PLATFORM_URL = "https://app.fooz.com.br/login";

/** Mesmo endereço acima, sem protocolo, para exibição. */
export const NEW_PLATFORM_LABEL = "app.fooz.com.br/login";

/** Canal de atendimento exibido no rodapé do aviso de migração. */
export const SUPPORT_PHONE_LABEL = "+55 81 98946-5110";
export const SUPPORT_WHATSAPP_URL = "https://wa.me/5581989465110";

/**
 * Features cujo conteúdo foi migrado para a nova plataforma.
 *
 * Rotas com uma destas features deixam de renderizar a tela original e passam
 * a exibir o aviso de migração (@/pages/Migrated/MigrationNotice.vue), e os
 * itens correspondentes somem do menu lateral.
 *
 * Para devolver uma tela ao legado, basta remover a feature desta lista.
 */
export const MigratedFeatures = [
  MenuFeatures.DASHBOARD,
  MenuFeatures.CONSUMPTION,
  MenuFeatures.CONSUMPTION_BY_TARIFF,
  MenuFeatures.ALERTS,
  MenuFeatures.CALLEDS,
  MenuFeatures.RESERVOIR,
  MenuFeatures.UNITS,
  MenuFeatures.GOAL_FORECASTS,
  MenuFeatures.REPORTS,
  MenuFeatures.CONFIGS,
  MenuFeatures.IA_AGENT,

  SubMenuFeatures.GOAL_ALERTS,
  SubMenuFeatures.TELEMETRY_ALERTS,
  SubMenuFeatures.CONSUMPTION_ALERTS,

  SubMenuFeatures.ECONOMY_REPORT,
  SubMenuFeatures.CALLED_REPORT,
  SubMenuFeatures.ALERTS_REPORT,
  SubMenuFeatures.TELEMETRY_REPORT,

  SubMenuFeatures.USERS_CONFIG,
  SubMenuFeatures.MODEMS_CONFIG,
  SubMenuFeatures.ALERTS_CONFIG,
  SubMenuFeatures.PERMISSIONS_CONFIG,
  SubMenuFeatures.WATERAUTHORITIES_CONFIG,
  SubMenuFeatures.CONTRACTS_CONFIG,
  SubMenuFeatures.SIGNATURE_CONFIG,
  SubMenuFeatures.DATES_CONFIG,
];

/**
 * Features que continuam sendo atendidas por esta plataforma — o bloco
 * "Gestão" do menu lateral. Espelha `subitems` em @/components/Sidebar.
 */
export const LegacyFeatures = [
  MenuFeatures.PROJECTS,
  SubMenuFeatures.PROJECTS_KITS,
  SubMenuFeatures.PROPOSALS,
  MenuFeatures.WATERSCAM,
  MenuFeatures.WATERFIX,
  MenuFeatures.SOLUTIONS,
];

export const isMigratedFeature = (feature) =>
  !!feature && MigratedFeatures.includes(feature);

/**
 * Indica se o usuário tem permissão para pelo menos uma tela migrada — usado
 * para decidir se o atalho de aviso aparece no menu lateral.
 */
export const hasMigratedFeature = (permissions) =>
  Array.isArray(permissions) && permissions.some(isMigratedFeature);

/**
 * Indica se o usuário segue com acesso a algum módulo que não migrou — usado
 * para escolher a versão do aviso que fala da Gestão de Projetos.
 */
export const hasLegacyFeature = (permissions) =>
  Array.isArray(permissions) &&
  permissions.some((feature) => LegacyFeatures.includes(feature));
